import styled from '@emotion/styled';

const StyledBreadcrumb = styled.div((props) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: props.bottom,
  'h2': {
    padding: '0 !important'
  },
  'button': {
    fontSize: 14,
    lineHeight: '20px',
    padding: '8px 24px',
    minWidth: 0,
    width: 'auto',
    display: 'flex',
    alignItems: 'center',
    'svg': {
      marginRight: 10
    },
    '&:last-child': {
      marginLeft: 16
    }
  }
}))

export {
  StyledBreadcrumb
}
